import React from "react";
import logo from "../assest/Images/mindWellIcon.png";
import { Link, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { ForgetUser } from "../../api/helper";
import { ShowToast } from "../../helpers/ToastService";

function ForgetPassword() {
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    watch,
    reset,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    try {
      const newData = await ForgetUser(data);
      // console.log()
      reset();
      // navigate("/ResetPassword");
      ShowToast(newData.data.message, "success");
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <div className="forgot-password-container">
      <div className="forgot-password-modal">
        <button className="close-btn" onClick={() => navigate("/")}>
          &times;
        </button>

        <div className="text-center">
          <img src={logo} alt="Logo" className="forgot-password-logo" />
          <h2 className="forgot-password-title">Forgot Password</h2>
          <p className="forgot-password-subtext">
            Please enter your email address to reset your password
          </p>
        </div>

        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="form-group">
            <label>Email address</label>
            <input
              type="email"
              className="form-control"
              {...register("email", { required: true })}
            />
            {errors.email && (
              <span className="error-text">Email is required</span>
            )}
          </div>
          <button type="submit" className="submit-btn">
            Submit
          </button>
        </form>
      </div>
    </div>
  );
}

export default ForgetPassword;
